import type { RefObject } from 'react';
import { useCallback, useEffect, useState } from 'react';

export function useScrollPercentage(
  scrollContainerRef: RefObject<HTMLDivElement | null>,
) {
  const [scrollLeftPercentage, setScrollLeftPercentage] = useState(0);
  const [scrollRightPercentage, setScrollRightPercentage] = useState(100);

  const handleScroll = useCallback(() => {
    const container = scrollContainerRef.current;
    if (!container) return;

    const scrollLeft = container.scrollLeft;
    const scrollWidth = container.scrollWidth;
    const scrolledLeft = (scrollLeft / scrollWidth) * 100;
    setScrollLeftPercentage(scrolledLeft);

    const scrollRight = container.scrollLeft + container.clientWidth;
    const scrolledRight = (scrollRight / scrollWidth) * 100;
    setScrollRightPercentage(100 - scrolledRight);
  }, [scrollContainerRef]);

  useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container) return;

    container.addEventListener('scroll', handleScroll);

    handleScroll();

    return () => {
      container.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll, scrollContainerRef]);

  return { scrollLeftPercentage, scrollRightPercentage };
}
